import {
  CountriesApiRes,
  CountryApiRes,
  DataDispatchTypes,
  GovernmentsApiRes,
  GovernmentApiRes,
  PoliticalPartiesApiRes,
  PoliticalPartyApiRes,
  PoliticiansApiRes,
  PoliticianApiRes,
  SET_COUNTRIESDATA,
  SET_COUNTRYDATA,
  SET_GOVERNMENTSDATA,
  SET_GOVERNMENTDATA,
  SET_POLITICALPARTIESDATA,
  SET_POLITICALPARTYDATA,
  SET_POLITICIANSDATA,
  SET_POLITICIANDATA,
  SearchGovernmentsApiRes,
  SearchPoliticalPartiesApiRes,
  SearchPoliticiansApiRes,
  SET_SEARCH_POLITICIANSDATA,
  SET_SEARCH_POLITICALPARTIESDATA,
  SET_SEARCH_GOVERNMENTSDATA,
  SUBMIT_POLITICIAN_FEEDBACK,
  SUBMIT_PARTY_FEEDBACK,
  SUBMIT_GOVERNMENT_FEEDBACK,
  DELETE_POLITICIAN_FEEDBACK,
  DELETE_POLITICALPARTY_FEEDBACK,
  DELETE_GOVERNMENT_FEEDBACK,
} from "../../types/data/DataActionTypes";

interface DataInitialState {
  countriesData?: CountriesApiRes;
  countryData?: CountryApiRes;
  politiciansData?: PoliticiansApiRes;
  politicianData?: PoliticianApiRes;
  politicalPartiesData?: PoliticalPartiesApiRes;
  politicalPartyData?: PoliticalPartyApiRes;
  governmentsData?: GovernmentsApiRes;
  governmentData?: GovernmentApiRes;
  govSearchRes?: SearchGovernmentsApiRes;
  politicalPartiesSearchRes?: SearchPoliticalPartiesApiRes;
  politiciansSearchRes?: SearchPoliticiansApiRes;
}
const initialState: DataInitialState = {};

const DataReducer = (
  state: DataInitialState = initialState,
  action: DataDispatchTypes
): DataInitialState => {
  switch (action.type) {
    case SET_COUNTRIESDATA:
      return {
        ...state,
        countriesData: action.payload,
      };
    case SET_COUNTRYDATA:
      return {
        ...state,
        countryData: action.payload,
      };
    //--------------------------------------------------------------------
    case SET_POLITICIANSDATA:
      return {
        ...state,
        politiciansData: action.payload,
      };

    case SET_POLITICIANDATA:
      return {
        ...state,
        politicianData: action.payload,
      };
    case SET_SEARCH_POLITICIANSDATA:
      return {
        ...state,
        politiciansSearchRes: action.payload,
      };
    case SUBMIT_POLITICIAN_FEEDBACK:
      return {
        ...state,
        politicianData: action.payload,
      };
    case DELETE_POLITICIAN_FEEDBACK:
      let politicianFeedbackDeleteIndex: number = 0;

      politicianFeedbackDeleteIndex =
        state.politicianData?.politician?.reviews?.findIndex(
          (feedback) => feedback._id === String(action.payload)
        )!;

      state.politicianData?.politician.reviews?.splice(
        politicianFeedbackDeleteIndex,
        1
      );
      return {
        ...state,
      };

    //---------------------------------------------------------------------
    case SET_POLITICALPARTIESDATA:
      return {
        ...state,
        politicalPartiesData: action.payload,
      };

    case SET_POLITICALPARTYDATA:
      return {
        ...state,
        politicalPartyData: action.payload,
      };
    case SET_SEARCH_POLITICALPARTIESDATA:
      return {
        ...state,
        politicalPartiesSearchRes: action.payload,
      };
    case SUBMIT_PARTY_FEEDBACK:
      return {
        ...state,
        politicalPartyData: action.payload,
      };
    case DELETE_POLITICALPARTY_FEEDBACK:
      let politicalPartyFeedbackDeleteIndex: number = 0;

      politicalPartyFeedbackDeleteIndex =
        state.politicalPartyData?.politicalParty.reviews?.findIndex(
          (feedback) => feedback._id === String(action.payload)
        )!;
      state.politicalPartyData?.politicalParty.reviews?.splice(
        politicalPartyFeedbackDeleteIndex,
        1
      );
      return {
        ...state,
      };
    //----------------------------------------------------------------------------
    case SET_GOVERNMENTSDATA:
      return {
        ...state,
        governmentsData: action.payload,
      };
    case SET_GOVERNMENTDATA:
      return {
        ...state,
        governmentData: action.payload,
      };
    case SET_SEARCH_GOVERNMENTSDATA:
      return {
        ...state,
        govSearchRes: action.payload,
      };
    case SUBMIT_GOVERNMENT_FEEDBACK:
      return {
        ...state,
        governmentData: action.payload,
      };
    case DELETE_GOVERNMENT_FEEDBACK:
      let govFeedbackDeleteIndex: number = 0;

      govFeedbackDeleteIndex =
        state.governmentData?.government.reviews?.findIndex(
          (feedback) => feedback._id === String(action.payload)
        )!;
      state.governmentData?.government.reviews?.splice(
        govFeedbackDeleteIndex,
        1
      );
      return {
        ...state,
      };
    default:
      return state;
  }
};
export default DataReducer;
